import React from 'react';
import { AnimatePresence, motion, useScroll, useMotionValueEvent } from 'framer-motion';

// Botón de reserva que acompaña el scroll: aparece al pasar el hero.
const SHOW_AFTER_PX = 480;

function FloatingBookingCTA() {
  const { scrollY } = useScroll();
  const [visible, setVisible] = React.useState(false);

  useMotionValueEvent(scrollY, "change", (latest) => {
    setVisible(latest > SHOW_AFTER_PX);
  });

  return (
    <AnimatePresence>
      {visible && (
        <motion.a
          href="/book"
          initial={{ opacity: 0, y: 12 }}
          animate={{ opacity: 1, y: 0 }}
          exit={{ opacity: 0, y: 12 }}
          transition={{ duration: 0.25, ease: "easeOut" }}
          className="btn-pill btn-pill--vino shadow-lg ring-1 ring-white/25"
        >
          Reservar ahora <span className="arrow" aria-hidden="true">→</span>
        </motion.a>
      )}
    </AnimatePresence>
  );
}

export default FloatingBookingCTA;
